<template>
  <div>
    <div class="row page-title-header">
      <div class="col-12">
        <div class="page-header">
          <b-breadcrumb class="m-0">
            <b-breadcrumb-item
              :to="{
                name: 'DashboardHome',
              }"
            >
              <i class="fa fa-home"></i>
            </b-breadcrumb-item>

            <b-breadcrumb-item>
              報表中心
            </b-breadcrumb-item>
            <b-breadcrumb-item
              :to="{
                name: 'PushedMessageList',
              }"
            >
              LINE 推播紀錄
            </b-breadcrumb-item>

            <b-breadcrumb-item active>{{ title }}</b-breadcrumb-item>
          </b-breadcrumb>
        </div>
      </div>
    </div>
    <b-form class="row">
      <div class="col-12">
        <b-overlay :show="showLoading">
          <b-card :title="title">
            <b-card-body>
              <validation-error-alert v-if="validationErrors" :errors="validationErrors"></validation-error-alert>
              <b-form-group label="Message" class="col-12 col-sm-12 col-lg-12">
                <jsonEditor
                  v-model="pushedMessage.message"
                  height="200px"
                  readonly="readonly"
                >
                </jsonEditor>
              </b-form-group>

              <b-row v-for="(template, index) in templates" :key="index">
                <b-form-group label="Live Preview" class="col-12 col-sm-6 col-lg-3">
                  <div class="p-2" style="background-color: #849ebf;">
                    <div id="preview" v-html="lineFlexCard(template)"></div>
                  </div>
                </b-form-group>

                <b-form-group label="Value" class="col-12 col-sm-6 col-lg-9">
                  <editor
                    v-model="template.value"
                    width="100%"
                    height="200px"
                    @init="editorInit"
                    lang="json"
                    theme="chrome"
                  >
                  </editor>
                </b-form-group>
              </b-row>

              <b-row class="my-3">
                <b-col>
                  <b-button class="mr-3" @click="handleCancel" variant="outline-danger">返回</b-button>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-overlay>
      </div>
    </b-form>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import flex2html from '/libs/flex2html'
import jsonEditorMixin from "@/mixins/jsonEditor";
import dataChartApi from "@/apis/data-chart";
import JsonEditor from "@/components/Dashboard/JsonEditor.vue";

export default {
  components: {
    JsonEditor,
  },
  mixins: [jsonEditorMixin],
  data () {
    return {
      title: '',
      showLoading: true,
      isEditing: true,
      validationErrors: null,
      pushedMessage: {
        message: "",
      },
      templates: [],
      organizationName: this.$store.state.general.organization.name,
    }
  },
  computed: {
    ...mapState('general', {
      organization: state => state.organization,
    }),
    isShow() {
      return this.$route.name == 'TemplateShow'
    },
    isEdit() {
      return this.$route.name == 'TemplateEdit'
    }
  },
  mounted() {
    this.fetchMessage()
    this.isEditing = false
  },
  methods: {
    lineFlexCard(template) {
      let res = ''
      try {
        let obj = JSON.parse(template.value)
        res = flex2html(obj)
      } catch (e) {
        // ignore
        console.error(e)
      }
      return res
    },
    async fetchMessage() {
      const response = await dataChartApi.getPushMessage(this.$route.params.pushed_message_id)
      this.pushedMessage = response.data.data
      this.title = `LINE推播紀錄-${response.data.data.customer_name ?? response.data.data.outer_code}`
      this.showLoading = false

      // 解析 message 字串為 JSON 物件，然後篩選出 type 為 "flex" 的物件，並只保留 contents 內容
      let messageArray;
      try {
        messageArray = JSON.parse(response.data.data.message);
        if (!Array.isArray(messageArray)) {
          messageArray = [messageArray];
        }
      } catch (e) {
        console.error('Failed to parse message:', e);
        messageArray = [];
      }

      this.templates = messageArray
        .filter(item => {
          return item && item.type === 'flex';
        })
        .map(item => ({
          type: 'json',
          value: JSON.stringify(item.contents, null, 2)
        }))
    },
    handleCancel () {
      this.$router.push({name: 'PushedMessageList'})
    }
  }
}
</script>

<style>
@import "../../../../libs/flex2html.css";
</style>
